type Layout = 'default' | 'prescription';

interface UseLayout {
    currentLayout: Ref<Layout>;
    setLayout: (layout: Layout) => void;
}

export function useLayout(): UseLayout {
    const currentLayout = useState<Layout>('layout', () => 'default');

    function setLayout(layout: Layout): void {
        currentLayout.value = layout;
    }

    return {
        currentLayout,
        setLayout,
    };
}
